import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { openSnackbar } from 'store/slices/snackbar';
import { makeStyles } from '@mui/styles';
import { NavLink, useNavigate } from 'react-router-dom';
import {
    Grid,
    IconButton,
    MenuItem,
    Typography,
    TextField,
    Tooltip,
    Button,
    Select,
    FormControl,
    Switch,
    FormControlLabel
} from '@mui/material';
import { createFilterOptions } from '@mui/material/Autocomplete';

import useAuth from 'hooks/useAuth';
import SubCard from 'ui-component/cards/SubCard';
import AddCircleTwoTone from '@mui/icons-material/AddCircleTwoTone';
import ContentCopyTwoToneIcon from '@mui/icons-material/ContentCopyTwoTone';
import ArrowForwardTwoToneIcon from '@mui/icons-material/ArrowForwardTwoTone';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import MicIcon from '@mui/icons-material/Mic';
import MicRecorder from 'mic-recorder-to-mp3';
import { addQuery, fetchAnswer, selectQueries } from './conversationSlice';
import { useSpeechRecognition } from 'react-speech-recognition';
import StopCircleIcon from '@mui/icons-material/StopCircle';
import { getTranslates } from './preferences/preferenceApi';
import {
    setTranslates,
    selectTranslates
} from './preferences/preferenceSlice';
import Message from './assets/message.svg';

import MainCard from 'ui-component/cards/MainCard';
import { SwapCalls } from '@mui/icons-material';
const height = 200;
const labelOffset = -6;
const filter = createFilterOptions();
const apiHost = process.env.REACT_APP_API_URL;
const project = 'translation';
const languageMenu = [
    {
        value: 'tiengviet',
        label: 'Tiếng Việt'
    },
    {
        value: 'tienganh',
        label: 'Tiếng Anh'
    },
    {
        value: 'tiengtrung',
        label: 'Tiếng Trung'
    },
    {
        value: 'tienghan',
        label: 'Tiếng Hàn'
    }
];

const useStyles = makeStyles((theme) => ({
    textFieldResponseClass: {
        '& .css-8iztpu-MuiInputBase-input-MuiInput-input.Mui-disabled': {
            '-webkit-text-fill-color': 'unset',
            color: 'black',
            height: '100%',
            cursor: 'text'
        }
    }
}));

export default function Translate() {
    const navigate = useNavigate();
    const classes = useStyles();
    const [isCopyTranslation, setCopyTranslation] = useState(false);
    const [language, setLanguage] = useState('Tiếng Việt');
    const [languageTranslate, setLanguageTranslate] = useState('Tiếng Anh');

    const translates = useSelector(selectTranslates);

    const [translates_, setTranslates_] = useState([]);
    const tileRef = useRef(null);
    const [translateId, setTranslateId] = useState('');

    const queries = useSelector(selectQueries);
    const { fetchBillings } = useAuth();
    const [isRecording, setIsRecording] = useState(false);
    const [message, setMessage] = useState('');
    const [response, setResponse] = useState('');
    const [isMicro, setIsMicro] = useState(true);
    const { transcript, listening, resetTranscript, browserSupportsSpeechRecognition } = useSpeechRecognition();
    const [isBlock, setIsBlock] = useState(false);
    const dispatch = useDispatch();
    const [recorder, setRecoder] = useState(
        new MicRecorder({
            bitRate: 128
        })
    );
    const [isReadClicked, setIsReadClicked] = useState(false);
    const [isReadHovered, setIsReadHovered] = useState(false);
    const [audio, setAudio] = useState(new Audio());

    const [isAutoTranslate, setIsAutoTranslate] = useState(false);
    const [isGrammarCheck, setIsGrammarCheck] = useState(false);

    useEffect(() => {
        if (!browserSupportsSpeechRecognition) {
            setIsMicro(false);
            // return <span>Browser doesn't support speech recognition.</span>;
        }
    }, []);

    useEffect(() => {
        fetchBillings();
        setResponse(queries[queries.length - 1]?.response);
        // console.log(queries)
    }, [queries.length, queries[queries.length - 1]]);

    useEffect(() => {
        setResponse('');
    }, []);

    useEffect(() => {
        fetchTranslates();
    }, []);

    useEffect(() => {
        if (!translates) {
            fetchTranslates();
        }
    }, [translates, dispatch]);

    useEffect(() => {
        if (message != '' && isAutoTranslate) {
            const timeoutId = setTimeout(() => {
                handleQuestion(message);
            }, 1000);
            return () => clearTimeout(timeoutId);
        }
    }, [message, isAutoTranslate]);

    useEffect(() => {
        if (message != '' && isGrammarCheck) {
            console.log('grammar check!');
        }
    }, [message, isGrammarCheck]);

    async function fetchTranslates() {
        return await getTranslates()
            .then((fetchedTranslates) => {
                setTranslates_(fetchedTranslates);
                dispatch(setTranslates(fetchedTranslates));
            })
            .catch((error) => {
                console.error('Failed to fetch conversations: ', error);
            });
    }

    const handleCopyTranslation = () => {
        navigator.clipboard.writeText(response).then(() => {
            setCopyTranslation(true);
            setTimeout(() => {
                setCopyTranslation(false);
            }, 2000);
        });
    };

    const handleLanguageChange = (event) => {
        if (event.target.value === languageTranslate) {
            setLanguageTranslate(language);
            setLanguage(event.target.value);
        } else {
            setLanguage(event.target.value);
        }
    };
    const handleLanguageTranslateChange = (event) => {
        if (event.target.value === language) {
            setLanguage(languageTranslate);
            setLanguageTranslate(event.target.value);
        } else {
            setLanguageTranslate(event.target.value);
        }
    };
    const handleSwapLanguage = () => {
        console.log(language);
        console.log(languageTranslate);
        setLanguage(languageTranslate);
        setLanguageTranslate(language);
    };

    const handleQuestion = (question) => {
        question = question.trim();
        if (question === '') return;
        dispatch(addQuery({ prompt: question }));
        dispatch(fetchAnswer({ question, language, languageTranslate }));
    };

    async function callWhisper(file) {
        // console.log('before call');
        const fileUri = URL.createObjectURL(file);
        const formData = new FormData();
        formData.append('model', 'whisper-1');
        formData.append('file', file);
        formData.append('response_format', 'text');
        const res = await fetch('https://api.openai.com/v1/audio/transcriptions', {
            method: 'POST',
            body: formData,
            headers: {
                Authorization: 'Bearer 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'
            }
        });

        const text = await res.text();
        setMessage(text.toLowerCase().replaceAll('\n', ''));
        // console.log('callChatGPTRes', res.status);
        // console.log('callChatGPTRes', text);
        return text.trim();
    }

    const start = () => {
        // console.log(recorder);

        if (isBlock || !recorder) {
            console.log('Permission Denied or Recorder not initialized');
        } else {
            recorder
                .start()
                .then(() => {
                    setIsRecording(true);
                })
                .catch((e) => console.error(e));
        }
    };

    const stop = async () => {
        if (isRecording === true && recorder) {
            try {
                const [buffer, blob] = await recorder.stop().getMp3();
                const file = new File(buffer, 'speech.mp3', {
                    type: blob.type,
                    lastModified: Date.now()
                });
                // console.log(file);
                const blobUrl = URL.createObjectURL(file);
                // console.log(blobUrl);
                await callWhisper(file, file.name);

                setIsRecording(false);
            } catch (e) {
                console.log(e);
            }
        }
    };

    const handleConversationClick = (index) => {
        // fetch the conversation from the server and setConversation in the store
        fetch(`${apiHost}/api/translates/${index}`, {
            method: 'GET'
        })
            .then((response) => response.json())
            .then((data) => {
                navigate('/workspace/' + project);
                setTranslateId(index);
                // console.log(data)
                setMessage(data[0]['prompt']);
                setResponse(data[0]['response']);
            });
    };

    return (
        <MainCard
            className="h-100"
            contentSX={{ padding: 0 }}
            headersx={{ padding: '10px' }}
            sx={{
                bgcolor: 'white'
            }}
            style={{
                height: 800
            }}
        >
            <Grid container spacing={0} sx={{ minHeight: '750px', padding: 0 }}>
                <Grid item xs={3} sx={{ minHeight: '100%', padding: '0px' }}>
                    <SubCard
                        sx={{ minHeight: '100%', padding: '0px', height: '720px' }}
                        headersx={{ textAlign: 'center' }}
                        title={
                            <Grid item xs={12} textAlign="center">
                                <NavLink to={'/workspace/' + project}>
                                    <Button
                                        variant="contained"
                                        sx={{ padding: 1.8, paddingX: 6, backgroundColor: '#156DA2' }}
                                        startIcon={<AddCircleTwoTone />}
                                        onClick={() => {
                                            setMessage('');
                                            setResponse('');
                                        }}
                                    >
                                        Bản dịch mới
                                    </Button>
                                </NavLink>
                            </Grid>
                        }
                    >
                        {/* <Navigation navOpen={navOpen} setNavOpen={setNavOpen} /> */}
                        <Typography variant="h5">Các bản dịch đã thực hiện</Typography>
                        {/* {conversations && (
                            // <div className="conversations-container mb-auto max-h-[25rem] overflow-y-auto">
                            <div>
                                {conversations?.map((conversation) => (
                                    <ConversationTile
                                        key={conversation.id}
                                        conversation={conversation}
                                        selectConversation={(id) => handleConversationClick(id)}
                                        onDeleteConversation={(id) => handleDeleteConversation(id)}
                                        onSave={(conversation) => updateConversationName(conversation)}
                                    />
                                ))}
                            </div>
                        )} */}
                        {/* <div className="conversations-container mb-auto max-h-[25rem] overflow-y-auto"> */}
                        {translates_?.length > 0 &&
                            translates_?.map((translate) => {
                                return (
                                    <div
                                        key={translate.id}
                                        ref={tileRef}
                                        onClick={() => {
                                            handleConversationClick(translate.id);
                                        }}
                                        className={`my-auto mt-1 flex h-9 cursor-pointer items-center justify-between gap-4 rounded-xl px-4 py-6 hover:bg-gray-100 ${
                                            translateId === translate.id ? 'bg-gray-100' : ''
                                        }`}
                                    >
                                        <div className={`flex ${translateId === translate.id ? 'w-[75%]' : 'w-[95%]'} gap-2`}>
                                            <img src={Message} className="ml-1 w-5"></img>
                                            <p className="my-auto overflow-hidden overflow-ellipsis whitespace-nowrap text-sm font-normal leading-6 text-eerie-black">
                                                {translate.name}
                                            </p>
                                        </div>
                                        {/* <Typography variant="body">{translate.name}</Typography> */}
                                        {/* <br /> */}
                                    </div>
                                );
                            })}
                    </SubCard>
                </Grid>
                <Grid item xs={9} sx={{ padding: '0px' }}>
                    <Grid container>
                        <Grid item xs={12}>
                            <SubCard sx={{ padding: '0px' }}>
                                <Grid item xs={12}>
                                    <FormControl sx={{ m: 1, minWidth: 140, padding: 0 }} size="small">
                                        {/* <InputLabel id="demo-select-small-label">Chọn ngôn ngữ</InputLabel> */}
                                        <Select
                                            labelId="demo-select-small-label"
                                            id="demo-select-small"
                                            value={language}
                                            // label="Ngôn ngữ"
                                            onChange={handleLanguageChange}
                                        >
                                            {languageMenu.map((data, index) => {
                                                return (
                                                    <MenuItem key={index} value={data.label}>
                                                        {data.label}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid container sx={{ border: '1px solid #ccc', borderRadius: '8px', padding: '8px 14px' }}>
                                    <Grid item xs={12} style={{ height: height, fontSize: '1rem' }}>
                                        <TextField
                                            fullWidth
                                            variant="standard"
                                            border="none"
                                            multiline
                                            onChange={(e) => {
                                                setMessage(e.target.value);
                                            }}
                                            value={isRecording === true ? 'Đang nghe...' : message}
                                            style={{ height, overflow: 'auto' }}
                                            InputProps={{
                                                disableUnderline: true
                                            }}
                                        ></TextField>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid container>
                                            <Grid item xs={9}>
                                                {isMicro && isRecording === false && (
                                                    <IconButton
                                                        aria-label="button-mic"
                                                        onClick={() => start()}
                                                        edge="end"
                                                        sx={{ marginRight: '8px' }}
                                                    >
                                                        <Tooltip title="Dịch bằng giọng nói">
                                                            <MicIcon fontSize="small" />
                                                        </Tooltip>
                                                    </IconButton>
                                                )}
                                                {isMicro && isRecording === true && (
                                                    <IconButton
                                                        aria-label="button-mic"
                                                        disableRipple
                                                        onClick={() => stop()}
                                                        edge="end"
                                                        sx={{ marginRight: '8px' }}
                                                    >
                                                        <Tooltip title="Đã nói xong">
                                                            <StopCircleIcon color="error" />
                                                        </Tooltip>
                                                    </IconButton>
                                                )}
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            defaultChecked={false}
                                                            onChange={() => setIsGrammarCheck(!isGrammarCheck)}
                                                        />
                                                    }
                                                    label="Sửa ngữ pháp"
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            defaultChecked={false}
                                                            onChange={() => setIsAutoTranslate(!isAutoTranslate)}
                                                        />
                                                    }
                                                    label="Tự động dịch"
                                                />
                                            </Grid>
                                            <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'end' }}>
                                                <IconButton
                                                    aria-label="button-copy-content"
                                                    onClick={() => {
                                                        handleQuestion(message);
                                                    }}
                                                    edge="end"
                                                    sx={{
                                                        marginRight: '0.5px',
                                                        color: 'white',
                                                        bgcolor: '#156DA2',
                                                        borderRadius: '50%',
                                                        '&.MuiButtonBase-root:hover': {
                                                            color: 'white',
                                                            bgcolor: '#156DA2',
                                                            opacity: 0.8
                                                        }
                                                    }}
                                                >
                                                    <Tooltip title="Dịch">
                                                        <ArrowForwardTwoToneIcon fontSize="small" />
                                                    </Tooltip>
                                                </IconButton>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </SubCard>
                        </Grid>
                        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                            <IconButton
                                aria-label="swap-languge-button"
                                onClick={(e) => {
                                    handleSwapLanguage();
                                }}
                                edge="end"
                                sx={{ color: '#156DA2' }}
                            >
                                <Tooltip title="Hoán đổi ngôn ngữ">
                                    <SwapCalls fontSize="mormal" />
                                </Tooltip>
                            </IconButton>
                        </Grid>
                        <Grid item xs={12}>
                            <SubCard>
                                <Grid item xs={12}>
                                    <FormControl sx={{ m: 1, minWidth: 140, padding: 0 }} size="small">
                                        {/* <InputLabel id="demo-select-small-label">Chọn ngôn ngữ</InputLabel> */}
                                        <Select
                                            labelId="demo-select-small-label"
                                            id="demo-select-small"
                                            value={languageTranslate}
                                            // label="Ngôn ngữ"
                                            onChange={handleLanguageTranslateChange}
                                        >
                                            {languageMenu.map((data, index) => {
                                                return (
                                                    <MenuItem key={index} value={data.label}>
                                                        {data.label}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid
                                    container
                                    sx={{ border: '1px solid #ccc', borderRadius: '8px', padding: '8px 14px', background: '#f5f5f5' }}
                                >
                                    <Grid item xs={12} style={{ height: height }}>
                                        <TextField
                                            disabled
                                            className={classes.textFieldResponseClass}
                                            fullWidth
                                            variant="standard"
                                            border="none"
                                            multiline
                                            value={response}
                                            style={{ height, overflow: 'auto' }}
                                            InputProps={{
                                                disableUnderline: true
                                            }}
                                        ></TextField>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid container>
                                            <Grid item xs={6}>
                                                <IconButton
                                                    aria-label="button-mic"
                                                    edge="end"
                                                    sx={{ marginRight: '0.5px' }}
                                                    onClick={async () => {
                                                        if (response === '') {
                                                            dispatch(
                                                                openSnackbar({
                                                                    open: true,
                                                                    anchorOrigin: { vertical: 'top', horizontal: 'center' },
                                                                    message: 'Bản dịch hiện tại đang trống',
                                                                    variant: 'alert',
                                                                    alert: {
                                                                        color: 'error'
                                                                    }
                                                                })
                                                            );
                                                        } else {
                                                            if (isReadClicked) {
                                                                audio.pause();
                                                                setIsReadClicked(false);
                                                            } else {
                                                                setIsReadClicked(true);
                                                                const new_audio = new Audio(
                                                                    `${apiHost}/api/t2s/vits?answer=${response}&api_key=qLQuunfY0ess1LFmup6tBJDwXFka5Ez1SPBH2NHXeo`
                                                                );
                                                                setAudio(new_audio);
                                                                new_audio.play();
                                                                new_audio.addEventListener('ended', () => {
                                                                    setIsReadClicked(false);
                                                                });
                                                            }
                                                        }
                                                    }}
                                                >
                                                    <Tooltip title="Nghe">
                                                        <VolumeUpIcon color={isReadClicked ? 'primary' : ''} fontSize="small" />
                                                    </Tooltip>
                                                </IconButton>
                                            </Grid>
                                            <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'end' }}>
                                                <IconButton
                                                    aria-label="button-copy-content"
                                                    onClick={(e) => {
                                                        handleCopyTranslation();
                                                    }}
                                                    edge="end"
                                                >
                                                    <Tooltip title={isCopyTranslation === false ? 'Sao chép' : 'Đã sao chép'}>
                                                        <ContentCopyTwoToneIcon
                                                            color={isCopyTranslation ? 'primary' : ''}
                                                            fontSize="small"
                                                        />
                                                    </Tooltip>
                                                </IconButton>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </SubCard>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </MainCard>
    );
}
